import {
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY,
} from '@atlassian/jira-common-constants/src/project-template-type-keys.tsx';

import { TEMPLATE_KEY as IT_SERVICE_MANAGEMENT_KEY } from '@atlassian/jira-project-template-select-v2/src/utils/templates/service-desk/it-service-management/constants.tsx';
import { TEMPLATE_KEY as IT_SERVICE_MANAGEMENT_NEW_KEY } from '@atlassian/jira-project-template-select-v2/src/utils/templates/service-desk/it-service-management-new/constants.tsx';

export const PACKAGE_NAME = 'jiraServicedeskGettingStartedPage';

export const UNKNOWN_PROJECT_TEMPLATE_KEY = '';

export const GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD = [
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM = [
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const JSM_EXCLUDED_TEMPLATES_FOR_NPLE = [
	IT_SERVICE_MANAGEMENT_KEY,
	IT_SERVICE_MANAGEMENT_NEW_KEY,
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const PACKAGE_TEAM_NAME = 'Sequoia';

export const DISABLE_NPLE_PROJECT_PROJECT_KEY = 'npleDisabled';

export const DEMO_ISSUE_LABEL = 'onboarding-learn-by-doing-demo-issue';
export const DEMO_ISSUE_ERROR_FLAG_ID = 'onboarding-sample-issue-error';

export const ManageQueuesArticleId = '5b7BuVaVJqmbyCZ2mbMYHD';
export const ViewIssueArticleId = '102lbF25oEeqn7GG1rXPUA';

export const DISABLE_NPLE_ERROR_FLAG_ID = 'disable-nple-error';
export const DISABLE_NPLE_SUCCESS_FLAG_ID = 'disable-nple-success';
